"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * List of URL parts which are parsed by this lib.
 */
exports.default = [
    "protocol",
    "hostname",
    "pathname",
    "search",
    "host",
    "port",
    "hash",
    "href"
];
//# sourceMappingURL=parts.js.map